export const SET_DEALS_ACTIVE = 'SET_DEALS_ACTIVE';
export const SET_CURRENT_DEALS = 'SET_CURRENT_DEALS';
export const SET_DEALS_TOGGLE = 'SET_DEALS_TOGGLE';
